import React from "react";
import { useState, useEffect } from "react";
import { MdOutlineWbSunny } from "react-icons/md";
import { LuMoon } from "react-icons/lu";

const ThemeToggle = ({ handleFunction }) => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    return (
        <button
            className={`toggle-container ${isDarkMode ? "dark" : ""}`}
            onClick={() => {
                setIsDarkMode(!isDarkMode);
                handleFunction();
            }}
        >
            <div className="icon moon d-flex justify-content-center align-items-center">
                {isDarkMode && <LuMoon size={18} />}
            </div>
            <div className="toggle-circle"></div>
            <div className="icon sun d-flex justify-content-center align-items-center">
                {!isDarkMode && <MdOutlineWbSunny size={18} />}
            </div>
        </button>
    );
};

export default ThemeToggle;
